import BasicService from "./basicService";
export default class SnackbarService extends BasicService {
    get props() {
        return this._props;
    }
    show(props) {
        this._props = Object.assign({ open: true }, props);
        this.notify("show");
    }
    close() {
        this._props = Object.assign(Object.assign({}, this.props), { open: false });
        this.notify("hide");
    }
}
export const snackbarService = new SnackbarService();
//# sourceMappingURL=snackbarService.js.map